import { Component, OnInit } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { EquipmentService } from '../equipment-service/equipment.service';


@Component({
  selector: 'app-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrls: ['./equipment-list.component.css']
})
export class EquipmentListComponent implements OnInit {
  search;
  equipments =[];
  user;
  status = "active";

  constructor(
    private equipmentService: EquipmentService
  ) { }

  ngOnInit() {
    this.getEquipments();
  }

  getEquipments() {
    let queryParam = {
      isAddon: false
    }
      this.equipmentService
        .getEquipments(queryParam)
        .subscribe(data => {
          if (data && data.length) {
            this.equipments = data;
          }else{
            this.equipments = [];
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
  }
  
  ngOnDestroy(): void {
  }

}
